import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../redux/reducer';
import { responsiveSidebarChange, updateSidebarTab } from '../../redux/action';
import { adminMenu, superAdminMenu, userMenu } from '../../config/sidebarItems';
import { Link } from 'react-router-dom';
import { apiUrl } from '../../config/constants';
import { Role } from '../../config/enum';
import { flashBarTheme } from '../../config/flashBar';
import instance from '../../service/axiosInstane';
import user from '../../assets/default.jpg';

type ActiveProps = {
  name: string;
  url: string;
  icon: JSX.Element;
};

const ResponsiveSidebarNew = () => {
  const dispatch = useDispatch();
  const activeTab = useSelector((state: StateProps) => state.defaultSideBarTab);
  const userInfo = useSelector((state: StateProps) => state.tokenInfo.userInfo);
  const isSidebar = useSelector((state: StateProps) => state.responsiveSidebar);
  const { role, firstName, profileImage } = userInfo;
  const [activeRole, setActiveRole] = useState<ActiveProps[]>([]);

  const [flashbar, setFlashbar] = useState({
    isOpen: false,
    message: '',
    type: '',
  });
  const [appInfo, setAppInfo] = useState({
    version: '',
    environment: '',
  });

  useEffect(() => {
    const currentpath = window.location.href.split('/');
    if (currentpath[currentpath.length - 1] === 'dashboard') {
      dispatch(updateSidebarTab('Dashboard'));
    }
    if (role === Role.SuperAdmin) {
      setActiveRole(superAdminMenu);
    } else if (role === Role.Admin) {
      setActiveRole(adminMenu);
    } else {
      setActiveRole(userMenu);
    }
    getInfo();
  }, []);

  const handleOnclick = (item: string) => {
    dispatch(updateSidebarTab(item));
  };

  const getInfo = async () => {
    await instance
      .get(`/app/info`)
      .then((response) => {
        if (response.status === 200) {
          setAppInfo(response.data);
        }
      })
      .catch((err) => {
        setFlashbar({
          ...flashbar,
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        });
      });
  };

  return (
    <div className="w-full">
      <div
        onClick={() => dispatch(responsiveSidebarChange(false))}
        className={`absolute ${
          isSidebar ? 'left-0 block ' : 'hidden'
        } h-screen w-full top-0 transition-all duration-200  ease-in-out`}
      >
        <div
          onClick={() => dispatch(responsiveSidebarChange(false))}
          className={`absolute ${
            isSidebar ? 'left-0 block' : 'hidden'
          } bg-white h-screen w-48 transition-all duration-200 ease-in-out top-16 border px-2 py-1 rounded-sm`}
        >
          {' '}
          <div>
            <div
              className={`flex bg-[#176B87] items-center  text-[white] shadow-sm border rounded-md`}
            >
              <div>
                <div className="p-2">
                  <img
                    src={profileImage ? `${apiUrl}/${profileImage}` : user}
                    width={45}
                    height={45}
                    className="rounded-full border-2 my-1"
                  />
                </div>
              </div>

              <div>
                <div className="text-sm">Welcome</div>
                <div className="uppercase font-semibold">
                  {firstName.length < 10
                    ? firstName
                    : firstName.substring(0, 8) + '...'}
                </div>
              </div>
            </div>
            <div className="text-sm">
              {activeRole?.map((item: ActiveProps, index: number) => {
                return (
                  <Link
                    key={index}
                    onClick={() => handleOnclick(item.name)}
                    to={item.url}
                    className={`flex items-center space-x-2  cursor-pointer py-2 ${
                      activeTab === item.name
                        ? `text-white bg-[#50a0d9] font-semibold shadow-sm`
                        : 'text-[gray]'
                    }  my-2 hover:bg-[#50a0d9] hover:text-white rounded-sm shadow-sm`}
                  >
                    <div className="ml-1">{item.icon}</div>
                    <div className="">{item.name}</div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResponsiveSidebarNew;
